module.exports = __webpack_public_path__ + "static/media/04.Stage Base.53008567.JPG";